import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

const articleImageMap: Record<string, string> = {
  'article-newbie-01': 'https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20flat%20lay%20of%20a%20smartphone%20displaying%20photo%20editing%20app%20interface%20on%20clean%20desk%20with%20soft%20natural%20light%2C%20creative%20workspace%20vibe%2C%20editorial%20photography%20style%20with%20gentle%20shadows%20and%20creamy%20beige%20background&width=800&height=480&seq=article-newbie-01&orientation=landscape',
  'article-update-02': 'https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20floating%20with%20glowing%20AI%20circuit%20patterns%20around%20it%20on%20a%20warm%20gradient%20background%20of%20soft%20yellow%20and%20cream%20tones%2C%20futuristic%20yet%20approachable%20tech%20aesthetic%2C%20clean%20composition%20with%20subtle%20shadows&width=800&height=480&seq=article-update-02&orientation=landscape',
  'article-filter-03': 'https://readdy.ai/api/search-image?query=A%20beautiful%20flat%20lay%20of%20color%20palette%20swatches%20and%20a%20phone%20showing%20photo%20editing%20app%20on%20a%20warm%20cream%20desk%20surface%2C%20creative%20studio%20atmosphere%20with%20soft%20natural%20side%20lighting%2C%20artistic%20composition&width=800&height=480&seq=article-filter-03&orientation=landscape',
};

export default function ArticleSection() {
  const featuredArticles = getFeaturedArticles();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
              热门文章推荐
            </h2>
            <p className="text-sm text-foreground-500">最新黄油相机使用教程与技巧分享</p>
          </div>
          <Link
            to="/category/shiyong-jiaocheng"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={articleImageMap[article.imageSeq]}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs font-medium rounded-full">
                    {article.readTime}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="text-xs text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full">
                    {article.tags[0]}
                  </span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}